// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"4baf3eea","44":"1ec85b86","249":"5a80e014","345":"a8a0728d","372":"cd892eec","453":"d80f6b7f","517":"597cf048","668":"77a1b0fc","720":"c6473c95","727":"b799547b","821":"e34a7585","834":"8c80ff26","981":"d3bc7755"}[chunkId] + ".chunk.js";
};